
export enum MediaType {
  NONE = '',
  FG_VIDEO = 'VIDEO',
  FG_IMAGE = 'IMAGE',
  BG_VIDEO = 'BACKGROUND_VIDEO',
  BG_IMAGE = 'BACKGROUND_IMAGE',
  BACKGROUND = 'BACKGROUND',  // IMAGE OR VIDEO for new upload only
  LOGO = 'LOGO'
}

export enum MediaOrigin {
  PREDEFINED = 'predefined',
  USER_ASSET = 'user_asset',
  MEETING_ASSET = 'meeting_asset'
}

export class Media {
  id: string;
  isNew: boolean;
  name: string;
  source: string;
  mp4: string;
  hls: string;
  type: MediaType;
  selected: boolean;
  origin: MediaOrigin;
  constructor(id, source, name,  mp4, type, origin) {
    this.id = id;
    this.isNew = false;
    this.source = source;
    this.name = name;
    this.mp4 = mp4;
    this.hls = '';
    this.type = type;
    this.selected = false;
    this.origin = origin;
  }
}
